"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderMenu = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("@emotion/react");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_button_1 = require("@ryerson/frontend.button");

var frontend_common_1 = require("@ryerson/frontend.common");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var rgba_1 = __importDefault(require("polished/lib/color/rgba"));

var react_2 = __importStar(require("react"));

var util_1 = require("../common/util");

exports.SliderMenu = styled_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\ttransition: left 0.3s linear;\n\tposition: fixed;\n\twidth: 100%;\n\ttop: 50px;\n\theight: 100vh;\n\tmaxheight: 100vh;\n\toverflowy: auto;\n\toverflowx: hidden;\n\tz-index: ", ";\n\n\t&.slide-open {\n\t\tleft: 0%;\n\t}\n\n\t&.slide-close {\n\t\tleft: -100%;\n\t}\n\n\t", "\n"])), frontend_common_1.IndexedLayers.header, function (props) {
  var theme = props.theme;
  return (0, react_1.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\t\t\tbackground-color: ", ";\n\t\t"])), theme.colors.primary.lighterGray);
});
var GlobalNavigation = styled_1.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\theight: 50px;\n\twidth: 100%;\n\ttop: 0;\n\t", "\n"])), function (props) {
  var theme = props.theme;
  return (0, react_1.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\t\t\tborder-bottom: 1px solid ", ";\n\t\t\tbackground-color: ", ";\n\t\t"])), theme.colors.primary.lightGray, theme.colors.primary.darkGray);
});

var closeMergeCartModal = function closeMergeCartModal(props) {
  var theme = props.theme;
  return (0, react_1.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\theight: 50px;\n\t\twidth: 50px;\n\t\tborder-left: 1px solid ", ";\n\t"])), (0, rgba_1.default)(theme.colors.primary.white, 0.1));
};

var Container = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\tpadding: 20px;\n"])));
var ButtonContainer = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\twidth: 100%;\n\tpadding-top: 30px;\n"])));

var MergeCartModalMobile = function MergeCartModalMobile(_ref) {
  var content = _ref.content,
      numberOfItems = _ref.numberOfItems,
      showMergeCartModal = _ref.showMergeCartModal,
      setShowMergeCartModal = _ref.setShowMergeCartModal;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var _theme$colors$primary = theme.colors.primary,
      darkGray = _theme$colors$primary.darkGray,
      gray = _theme$colors$primary.gray,
      white = _theme$colors$primary.white;

  var _react_2$default$useS = react_2.default.useState(false),
      _react_2$default$useS2 = _slicedToArray(_react_2$default$useS, 2),
      hasMounted = _react_2$default$useS2[0],
      setHasMounted = _react_2$default$useS2[1];

  var _ref3 = (0, react_2.useState)(""),
      _ref4 = _slicedToArray(_ref3, 2),
      bodyStyles = _ref4[0],
      setBodyStyles = _ref4[1];

  var _ref5 = (0, react_2.useState)({}),
      _ref6 = _slicedToArray(_ref5, 1),
      domNodeRefs = _ref6[0];

  var windowSize = (0, frontend_common_1.useWindowSize)();
  (0, react_2.useEffect)(function () {
    var _a, _b;

    if (hasMounted) {
      var sliderEl = domNodeRefs["merge-cart-modal"].current;
      (_a = sliderEl === null || sliderEl === void 0 ? void 0 : sliderEl.classList) === null || _a === void 0 ? void 0 : _a.toggle("slide-open");
      (_b = sliderEl === null || sliderEl === void 0 ? void 0 : sliderEl.classList) === null || _b === void 0 ? void 0 : _b.toggle("slide-close");
      var body = document === null || document === void 0 ? void 0 : document.querySelector("body");

      if (showMergeCartModal) {
        window.scrollTo(0, 0);
        setBodyStyles((body === null || body === void 0 ? void 0 : body.getAttribute("style")) || "");
        setTimeout(function () {
          body === null || body === void 0 ? void 0 : body.setAttribute("style", "overflow: hidden;");
        }, 100);
      } else {
        body && body.setAttribute("style", bodyStyles);
      }
    }
  }, [showMergeCartModal]);
  (0, react_2.useEffect)(function () {
    setHasMounted(true);
    setShowMergeCartModal(false);
    var body = document === null || document === void 0 ? void 0 : document.querySelector("body");

    if (showMergeCartModal) {
      window.scrollTo(0, 0);
      setBodyStyles((body === null || body === void 0 ? void 0 : body.getAttribute("style")) || "");
      setTimeout(function () {
        body === null || body === void 0 ? void 0 : body.setAttribute("style", "overflow: hidden;");
      }, 100);
    } else {
      body && body.setAttribute("style", bodyStyles);
    }
  }, []);

  var creatDomNodeRef = function creatDomNodeRef(fieldName) {
    domNodeRefs[fieldName] = (0, react_2.createRef)();
    return domNodeRefs[fieldName];
  };

  return (0, jsx_runtime_1.jsx)(exports.SliderMenu, {
    theme: theme,
    ref: creatDomNodeRef("merge-cart-modal"),
    className: "merge-cart-modal slide-close",
    css: {
      top: 100
    },
    children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      css: {
        height: windowSize[1] - 100,
        overflowY: "scroll"
      },
      direction: "column",
      children: [(0, jsx_runtime_1.jsx)(GlobalNavigation, {
        theme: theme,
        children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
          alignItems: "center",
          children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            grow: 1,
            children: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
              justifyContent: "flex-start",
              onClick: function onClick() {
                return setShowMergeCartModal(false);
              },
              children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                alignSelf: "center",
                css: {
                  marginLeft: 20
                },
                children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                  icon: "chevron-left",
                  size: "md",
                  onClick: function onClick() {
                    return setShowMergeCartModal(false);
                  },
                  color: white,
                  circled: true,
                  css: {
                    borderColor: gray
                  }
                })
              }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
                css: (0, react_1.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tpadding-left: 10px;\n\t\t\t\t\t\t\t\t\t"]))),
                children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
                  variant: "p",
                  color: theme.colors.tertiary.label,
                  size: "md",
                  children: content === null || content === void 0 ? void 0 : content.back
                })
              })]
            })
          }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
            children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
              style: closeMergeCartModal({
                theme: theme
              }),
              justifyContent: "center",
              alignItems: "center",
              children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                icon: "close",
                size: "sm",
                onClick: function onClick() {
                  return setShowMergeCartModal(false);
                },
                color: theme.colors.primary.white
              })
            })
          })]
        })
      }), (0, jsx_runtime_1.jsxs)(Container, {
        direction: "column",
        children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          css: {
            marginBottom: "30px"
          },
          variant: "h1",
          children: content.title.replace(/%plural%/g, numberOfItems > 1 ? "s" : "")
        }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          children: content.message.replace(/%number%/g, "".concat(numberOfItems)).replace(/%plural%/g, numberOfItems > 1 ? "s" : "")
        }), (0, jsx_runtime_1.jsxs)(ButtonContainer, {
          direction: "column",
          children: [(0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
            fullwidth: true,
            onClick: function onClick() {
              return setShowMergeCartModal(false);
            },
            label: content.ok
          }), (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
            fullwidth: true,
            background: darkGray,
            foreground: "light",
            css: {
              marginTop: "15px"
            },
            label: content.reviewCart,
            onClick: function onClick() {
              return (0, util_1.navigateLink)("/store", "/cart");
            }
          })]
        })]
      })]
    })
  });
};

exports.default = MergeCartModalMobile;